import React, { useEffect, useState } from "react";
import useGetPages from "@base/modules/wpApis/hooks/useGetPages";
import { initialPage } from "@base/themes/colorTheme";
import { responseUI } from "@base/themes/response";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import styles from "!!raw-loader!../medicalInfo/[id]/index.module.css";
import { Page } from "@base/types/wp";
import CommonStyles from "@components/CommonStyles";

const StyledWpContent = styled.div`
  ${styles}
`;

export default function ProductInfo() {
  //! state
  const { type } = useParams();
  const { data, error, isLoading, refetch } = useGetPages({ _embed: true, page: 1, per_page: 1, slug: type });
  const [productInfo, setProductInfo] = useState<Page>();

  //! function
  useEffect(() => {
    if (data?.data.length) {
      setProductInfo(data?.data[0] ?? {});
    }
  }, [data]);

  useEffect(() => {
    if (type) {
      refetch();
    }
  }, [type]);

  //! render
  return (
    <div className="relative min-h-[300px] py-5">
      <CommonStyles.SpinnerUI isSpinning={isLoading} />

      <StyledWpContent className={`${!productInfo ? "hidden" : ""}`}>
        <div className="bg-common-background wp-embed-content">
          <div className={`${responseUI.screen} ${initialPage.paddingX} max-[700px]:px-2`}>
            <div dangerouslySetInnerHTML={{ __html: productInfo?.content?.rendered ?? "" }}></div>
          </div>
        </div>
      </StyledWpContent>
    </div>
  );
}
